import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import ScheduleCard from './schedule-card';
import { addNewFlightPurchase } from '../../hooks/use-get-default-values';
import { TicketOrderFormType } from '../form-type';

export default function ScheduleSectionComponent() {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext<TicketOrderFormType>();

  const { append, remove } = useFieldArray({
    control,
    name: 'flightPurchases',
    keyName: '__customId',
  });

  const onAdd = React.useCallback(() => {
    append(addNewFlightPurchase());
  }, [append]);

  const onRemove = React.useCallback((index) => remove(index), [remove]);

  const { editable } = useFormState();

  const flightPurchases = getValues('flightPurchases');

  return (
    <div>
      {(flightPurchases || []).map((flightPurchase, idx) => (
        <React.Fragment key={flightPurchase.customId}>
          <ScheduleCard
            parentIndex={idx}
            onRemove={() => onRemove(idx)}
            fieldLength={flightPurchases.length}
          />
          <SeparatorVertical $margin={20}>
            <div style={{ height: 1, width: 4 }} />
          </SeparatorVertical>
        </React.Fragment>
      ))}
      {editable && (
        <Button buttonType="secondary" onClick={onAdd}>
          {t('common:add_extra', { extra: t('ticketOrders:schedule') })}
        </Button>
      )}
    </div>
  );
}
